import { jwtDecode } from "jwt-decode";
import { loadState } from "service/storage";


const getDecodedToken = () => {
  const result = loadState();
  if (!result?.app || !result.app?.accessToken) return null;
  const token = result.app.accessToken;
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
};

const getUserAuthorities = () => {
  const decoded = getDecodedToken();
  return decoded?.authorities || [];
};

export const hasPermission = (perm) => {
  if (perm === null || perm === undefined) return true;
  const authorities = getUserAuthorities();
  return authorities.includes(perm);
};